<template>
  <div class="card">
    <div class="card-body">
      <form v-on:submit.prevent="submit" >
        <div class="row">
            <div class="mb-3 col-md-6">
              <div class="form-floating" :class="{ 'form-group--error': $v.form.lastname.$error }">
                <input v-model="form.lastname" type="text" class="form-control" id="Nom" placeholder="Nom">
                <label for="Nom">Nom</label>
              </div>
              <div v-if="$v.form.lastname.$error" :class="$v.form.lastname.$error ? ' c-invalid-feedback ' : ''">
                <div class="error text-start" v-if="!$v.form.lastname.required"> Le champ est obligatoire.</div>
                <div class="error text-start" v-if="!$v.form.lastname.minLength">Le champ doit avoir au moins {{ $v.form.lastname.$params.minLength.min }} des lettres.</div>
              </div>
            </div>
            <div class="mb-3 col-md-6">
            <div class="form-floating" :class="{ 'form-group--error': $v.form.firname.$error }">
              <input v-model="form.firname" type="text" class="form-control" id="Prénom" placeholder="Prénom">
              <label for="Prénom">Prénom</label>
            </div>
            <div v-if="$v.form.firname.$error" :class="$v.form.firname.$error ? ' c-invalid-feedback ' : ''">
              <div class="error text-start" v-if="!$v.form.firname.required"> Le champ est obligatoire.</div>
              <div class="error text-start" v-if="!$v.form.firname.minLength">Le champ doit avoir au moins {{ $v.form.firname.$params.minLength.min }} des lettres.</div>
            </div>

          </div>

          <div class="mb-3 col-md-6">
            <div class="form-floating-c" :class="{ 'form-group--error': $v.form.phone.$error }">
              <VuePhoneNumberInput
                v-model="form.phone"
                :state="!$v.form.phone.$error"
                @update="validatePhone"
                autocomplete="no"
                :no-example="false"
                valid-color="#00A491" error-color="#e00025"
                :translations="translations"
                default-country-code="FR"
                :class=" $v.form.phone.$error? ' is-invalid ' :  ''"
              />
            </div>
            <div v-if="$v.form.phone.$error" :class="$v.form.phone.$error ? ' c-invalid-feedback ' : ''">
              <div class="error text-start" v-if="!$v.form.phone.required"> Le champ est obligatoire.</div>
              <div class="error text-start" v-if="!$v.form.phone.minLength">Le champ doit avoir au moins {{ $v.form.phone.$params.minLength.min }} des lettres.</div>
            </div>

          </div>
          <div class="mb-3 col-md-6">
           <button type="button" class="btn btn-outline-dark mt-2" @click="addParticipant" v-if="isAllowMoreParticipant">
             <span class="glyph-icon simple-icon-user"></span>
             + participants
           </button>
            <p  v-if="! isAllowMoreParticipant">
              impossible d'ajouter un autre participant ...
            </p>
          </div>
        </div>
        <div class="row mt-3"  v-for="(participant, index) in  $v.form.participants.$each.$iter " :key="index">
          <div class="col">
            <div class="card ">
                <div class="card-body">
                  <div class="row item-participe">
                    <div class="col-12">
                      <h4 class="text-start float-start">#Participant - {{parseInt(index)+1 }}</h4>
                      <span class="float-end" @click="retireParticipant(index)">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                             width="24" height="24"
                             viewBox="0 0 24 24"
                             style=" fill:#dc3545;"><path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z"></path></svg>
                      </span>
                    </div>
                    <div class="mb-3 col-md-6">
                      <div class="form-floating" :class="{ 'form-group--error': participant.lastname.$error }">
                        <input v-model="participant.lastname.$model" type="text" class="form-control" id="Nom" placeholder="Nom">
                        <label for="Nom">Nom</label>
                      </div>
                      <div v-if="participant.lastname.$error" :class="participant.lastname.$error ? ' c-invalid-feedback ' : ''">
                        <div class="error text-start" v-if="!participant.lastname.required"> Le champ est obligatoire.</div>
                        <div class="error text-start" v-if="!participant.lastname.minLength">Le champ doit avoir au moins {{ participant.lastname.$params.minLength.min }} des lettres.</div>
                      </div>

                    </div>

                    <div class="mb-3 col-md-6">
                      <div class="form-floating" :class="{ 'form-group--error': participant.firname.$error }">
                        <input v-model="participant.firname.$model" type="text" class="form-control" id="Nom" placeholder="Nom">
                        <label for="Nom">Prénom</label>
                      </div>
                      <div v-if="participant.firname.$error" :class="participant.firname.$error ? ' c-invalid-feedback ' : ''">
                        <div class="error text-start" v-if="!participant.firname.required"> Le champ est obligatoire.</div>
                        <div class="error text-start" v-if="!participant.firname.minLength">Le champ doit avoir au moins {{ participant.lastname.$params.minLength.min }} des lettres.</div>
                      </div>

                    </div>

                    <div class="mb-3 col-md-6">
                      <div class="form-floating" :class="{ 'form-group--error': participant.phone.$error }">
                        <input v-model="participant.phone.$model" type="text" class="form-control" id="Mobile" placeholder="Mobile">
                        <label for="Mobile">Mobile</label>
                      </div>
                      <div v-if="participant.$error" :class="participant.phone.$error ? ' c-invalid-feedback ' : ''">
                        <div class="error text-start" v-if="!participant.phone.required"> Le champ est obligatoire.</div>
                        <div class="error text-start" v-if="!participant.phone.minLength">Le champ doit avoir au moins {{ participant.phone.$params.minLength.min }} des lettres.</div>
                      </div>

                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
  import { required,minLength } from 'vuelidate/lib/validators'
  import {validationMixin} from "vuelidate";
  import data from "./data";
  import VuePhoneNumberInput from "vue-phone-number-input";
  import 'vue-phone-number-input/dist/vue-phone-number-input.css';
  export default {
    name: "Client",
    components: {
      VuePhoneNumberInput
    },
    props: {
      initUser: Object,
      maxTotal: Number,
    },
    created() {
      if (this.initUser) {
        this.form.lastname = this.initUser.lastname;
        this.form.firname = this.initUser.firname;
        this.form.phone = this.initUser.phone;
        this.form.participants = this.initUser.participants;
      }

      this.meetingsDays = data;
      this.loading = false;
    },
    data() {
      return {
        errors: [],
        translations:{
          countrySelectorLabel: 'Code pays',
          countrySelectorError: 'Choisir un pays',
          phoneNumberLabel: 'Numéro de téléphone',
          example: 'Exemple :'
        },
        form: {
          lastname: null,
          firname: null,
          phone: null,
          formattedPhone: null,
          participants: [],
        }
      };
    },
    mixins: [validationMixin],
    validations: {
      form: {
        lastname: {
          required,
          minLength: minLength(4)
        },
        firname: {
          required,
          minLength: minLength(4)
        },
        phone: {
          required,
          minLength: minLength(8)
        },
        participants: {
          $each: {
            lastname: {
              required,
              minLength: minLength(4)
            },
            firname: {
              required,
              minLength: minLength(4)
            },
            phone: {
              required,
              minLength: minLength(8)
            },
          }
        },
      }
    },
    computed: {
      isAllowMoreParticipant: function () {
        return this.maxTotal > this.form.participants.length + 1
      }

    },
    methods: {
      validatePhone(parms) {
        this.form.formattedPhone = parms.formattedNumber;
      },
      retireParticipant(index) {
        this.form.participants.splice(index, 1);
      },
      initDefautlForm (data) {
        this.form.firname = data.firname;
        this.form.lastname = data.lastname;
      },
      prepareFieldParticipant(nb) {
        this.form.participants = [];
        for(let i= 0 ; i < nb ; i++) {
          this.addParticipant();
        }
      },
      addParticipant() {
        this.form.participants.push({
          lastname: null,
          firname: null,
          phone: null
        })
      },
      submit() {
        console.log('submit!')
        this.$v.$touch();
        if (!this.$v.form.$invalid) {
          console.log("Valideted")
          this.$emit("do-user-info", {user: this.form})
        } else {
          console.log("error")
        }
        return false;
      }
    }
  }
</script>

